import './FocusableAtomic.less';
import React from 'react';
import classNames from 'classnames';
import invariant from 'invariant';
import { lazyload } from 'lib/components/lazyload';
import { Set } from 'immutable';
import { getAtomicFocusableProps } from './getAtomicFocusableProps';
import Debug from 'debug';
import { removeBlock } from 'lib/helpers';

const debug = Debug('focus-plugin');

const decorateComponent = (
	WrappedComponent,
	theme,
	findScrollParent
) =>
// 如果传入了 findScrollParent，则用 lazyload 组件进行装饰，支持懒加载。
// 对于超多 Atomic 的内容会有很大的性能提升
(findScrollParent ? lazyload : (() => x => x))({
	scroll: true,
	resize: true,
	placeholder: <span className="lazy-atomic-holder"></span>,
	findScrollParent,
})(
	class AtomicFocusDecorator extends React.Component {
		static wrapperClassName = WrappedComponent.wrapperClassName;
		static displayName = `Focusable(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

		render() {
			const { block, blockProps } = this.props;
			const { obtainFocusInfo } = blockProps;
			const { focused, onFocus } = obtainFocusInfo();

			return (
				<div
					key={block.getKey()}
					className={classNames(
						theme.focusable,
						WrappedComponent.wrapperClassName,
						{ [theme.focused]: focused }
					)}
					onClick={evt => onFocus()}>
					<WrappedComponent {...this.props} />
				</div>
			);
		}

		componentWillMount() {
			const { blockProps, block } = this.props;
			const keyStore = blockProps.focusableKeyStore;
			keyStore.add(block.getKey());
			debug('[Focus Block Added]', block.getKey(), keyStore.size);
		}

		componentWillUnmount() {
			const { blockProps, block } = this.props;
			const keyStore = blockProps.focusableKeyStore;
			keyStore.remove(block.getKey());
			debug('[Focus Block Removed]', block.getKey(), keyStore.size);
		}
	}
)

/**
 * 包装一个处理 Atomic Block 的插件，使其渲染的时候支持焦点获取机展示
 * @param {DraftEditorPlugin} plugin
 * @returns {DraftEditorPlugin}
 */
export function decorateFocusable(plugin, { keyStore, theme, findScrollParent }) {

	if (!plugin.getBlockRenderInfo) {
		return plugin;
	}

	// 重复装饰会导致组件重复渲染
	const getDecoratedComponent = (component) => (
		component._Decorated || (component._Decorated = decorateComponent(component, theme, findScrollParent))
	);

	return {
		...plugin,
		getBlockRenderInfo(block, store, pluginAPI) {
			const originInfo = plugin.getBlockRenderInfo(block, store, pluginAPI);

			if (!originInfo) return originInfo;

			const { component, editable, props } = originInfo;

			return {
				component: getDecoratedComponent(component),
				editable,
				props: {
					obtainFocusInfo: () => getAtomicFocusableProps(block, store),
					onRemove: (evt) => {
						removeBlock(store, block);
						if (evt && evt.stopPropagation) {
							evt.stopPropagation();
						}
					},
					focusableKeyStore: keyStore,
					...props,
				},
			}
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/focusPlugin/decorateFocusable.js